import { Label, Select } from '@lokalise/louis';

import type { JavaPropertiesSeparator } from '../../../../types';

type Option = { value: JavaPropertiesSeparator; label: string };

export interface JavaPropertiesSeparatorInputProps {
    value: JavaPropertiesSeparator;
    options: readonly Option[];
    onChange: (value: JavaPropertiesSeparator) => void;
}

const JavaPropertiesSeparatorInput = ({ value, options, onChange }: JavaPropertiesSeparatorInputProps) => (
    <Label id="JavaPropertiesSeparatorInput" text="Key-value separator">
        <Select
            aria-labelledby="JavaPropertiesSeparatorInput"
            value={options.filter((item) => value === item.value)[0]}
            options={options}
            onChange={(val) => {
                if (val === null) {
                    return;
                }
                onChange(val.value);
            }}
        />
    </Label>
);
export default JavaPropertiesSeparatorInput;
